import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
import LoaderPage from '~/components/jsx-helpers/loader-page';
import Copyright from './copyright';
import CookieYesToggle from './cookie-yes-toggle';
import ListOfLinks from '~/components/list-of-links/list-of-links';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import usePortalContext from '~/contexts/portal';
import './footer.scss';
function Footer({ data: { supporters, copyright, apStatement, facebookLink, twitterLink, linkedinLink } }) {
    const { rewriteLinks } = usePortalContext();
    React.useLayoutEffect(() => rewriteLinks === null || rewriteLinks === void 0 ? void 0 : rewriteLinks(document.querySelector('.page-footer')), [rewriteLinks]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "top" },
            React.createElement("div", { className: "boxed" },
                React.createElement(RawHTML, { html: supporters }),
                React.createElement("div", { className: "column col1" },
                    React.createElement("h3", null, "Help"),
                    React.createElement(ListOfLinks, null,
                        React.createElement("a", { href: "/contact" }, "Contact Us"),
                        React.createElement("a", { href: "https://help.openstax.org/s/" }, "Support Center"),
                        React.createElement("a", { href: "/faq" }, "FAQ"),
                        React.createElement("a", { href: "/print/" }, "Order Print"))),
                React.createElement("div", { className: "column col2" },
                    React.createElement("h3", null, "OpenStax"),
                    React.createElement(ListOfLinks, null,
                        React.createElement("a", { href: "/press" }, "Press"),
                        React.createElement("a", { href: "http://www2.openstax.org/l/218812/2016-10-04/lvk" }, "Newsletter"),
                        React.createElement("a", { href: "/careers" }, "Careers"))),
                React.createElement("div", { className: "column col3" },
                    React.createElement("h3", null, "Policies"),
                    React.createElement(ListOfLinks, null,
                        React.createElement("a", { href: "/accessibility-statement" }, "Accessibility Statement"),
                        React.createElement("a", { href: "/tos" }, "Terms of Use"),
                        React.createElement("a", { href: "/license" }, "Licensing"),
                        React.createElement("a", { href: "/privacy" }, "Privacy Notice"),
                        React.createElement(CookieYesToggle, null))))),
        React.createElement("div", { className: "bottom" },
            React.createElement("div", { className: "boxed" },
                React.createElement("div", { className: "copyrights" },
                    React.createElement(Copyright, { copyright: copyright, apStatement: apStatement })),
                React.createElement("ul", { className: "social" },
                    React.createElement("li", null,
                        React.createElement("a", { className: "btn btn-social facebook", href: facebookLink, title: "OpenStax on Facebook" },
                            React.createElement(FontAwesomeIcon, { icon: faFacebookF }))),
                    React.createElement("li", null,
                        React.createElement("a", { className: "btn btn-social twitter", href: twitterLink, title: "OpenStax on X" },
                            React.createElement(FontAwesomeIcon, { icon: faXTwitter }))),
                    React.createElement("li", null,
                        React.createElement("a", { className: "btn btn-social linkedin", href: linkedinLink, title: "OpenStax on LinkedIn" },
                            React.createElement(FontAwesomeIcon, { icon: faLinkedinIn }))),
                    React.createElement("li", null,
                        React.createElement("a", { className: "btn btn-social instagram", href: "https://www.instagram.com/openstax/", title: "OpenStax on Instagram" },
                            React.createElement(FontAwesomeIcon, { icon: faInstagram }))),
                    React.createElement("li", null,
                        React.createElement("a", { className: "btn btn-social youtube", href: "https://www.youtube.com/openstax/", title: "OpenStax on YouTube" },
                            React.createElement(FontAwesomeIcon, { icon: faYoutube }))),
                    React.createElement("li", null,
                        React.createElement("a", { className: "rice-logo", href: "http://www.rice.edu" },
                            React.createElement("img", { src: "/dist/images/rice-white-text.webp", alt: "Rice University logo", width: "99", height: "40" }))))))));
}
export default function FooterLoader() {
    return (React.createElement("div", { className: "page-footer", "data-analytics-nav": "Footer" },
        React.createElement(LoaderPage, { slug: "footer", Child: Footer })));
}
